import Layout from '@/components/Layout'
import Welcome from '@/components/Welcome'
import Login from '@/components/auth/Login'
import UpdateProfile from '@/components/auth/UpdateProfile'
import App from '@/components/App'
import NotFound from '@/components/errors/404'
import Firestore from '@/components/Firestore'
import ProjectsList from '@/components/ProjectsList'
import ProjectCard from '@/components/ProjectCard'
import AccountFund from '@/components/AccountFund'
import AccountWithdraw from '@/components/AccountWithdraw'
import AccountHistory from '@/components/AccountHistory'
import Faq from '@/components/faq'

import Vue from 'vue'

const routes = [{
    path: '/',
    component: Layout,
    children: [{
            path: '/',
            component: Welcome,
            name: 'Главная'
        },
        {
            path: '/login',
            component: Login,
            name: 'login'
        },
        {
            path: '/update-profile',
            component: UpdateProfile,
            name: 'Профиль',
            meta: {
                auth: true
            }
        },
        {
          path: '/account',
          component: AccountHistory,
          name: 'История счета',
          meta: {
              auth: true
          }
        },
        {
          path: '/fund-account',
          component: AccountFund,
          name: 'Пополнение счета',
          meta: {
              auth: true
          }
        },
        {
          path: '/withdraw-account',
          component: AccountWithdraw,
          name: 'Вывод средств',
          meta: {
              auth: true
          }
        },
        {
          path: '/projects-list',
          component: ProjectsList,
          name: 'Проекты',
          meta: {
              auth: true
          }
        },
        {
          path: '/project/:id',
          component: ProjectCard,
          name: 'Проект',
          props: true,
          meta: {
              auth: true
          }
        },
        {
          path: '/faq',
          component: Faq,
          name: 'Вопросы и ответы',
          meta: {
              auth: false
          }
        },
        {
            path: '/firestore',
            component: Firestore,
            name: 'Cloud Firestore',
            meta: {
                auth: true
            }
        },
        {
            path: '*',
            component: NotFound
        }
    ]
}]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js